/** Canonical `facility.premium_features` keys, the field's choices in schema.yaml. */
export enum EPremiumFeature {
  COMPETENCES = 'COMPETENCES',
  DAILY_PLANNING = 'DAILY_PLANNING',
  DISTRIBUTING = 'DISTRIBUTING',
  INTERNAL_ROTATION = 'INTERNAL_ROTATION',
  LLM_CHAT = 'LLM_CHAT',
  MATERNITY_PROTECTION = 'MATERNITY_PROTECTION',
  MULTIPLE_WBO = 'MULTIPLE_WBO',
  NETWORK_COMPETENCES = 'NETWORK_COMPETENCES',
  PART_TIME = 'PART_TIME',
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  PLANNING_GROUPS = 'PLANNING_GROUPS',
  QUALIFICATIONS = 'QUALIFICATIONS',
  SERVICE_GROUPS = 'SERVICE_GROUPS',
  UNITS_ONLY = 'UNITS_ONLY',
  VACATION = 'VACATION',
}
